import Relay from 'react-relay';

export interface DeleteTestInvocationMutationProps {
    testInvocation: {
        id: string;
        realId?: string;
    };
}

export default class DeleteTestInvocationMutation extends Relay.Mutation<DeleteTestInvocationMutationProps, any> {
    private mutationProps: DeleteTestInvocationMutationProps;

    constructor(props: DeleteTestInvocationMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {deleteTestInvocation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on DeleteTestInvocationPayload {
                deletedTestInvocationId
                deletedTestInvocationNodeId
                user {
                    testInvocations
                }
                success
                error
            }
        `;
    }

    getConfigs() {
        return [{
            // After a confirmed delete, evict the normalized testcase record and remove it from
            // every cached testInvocations connection. The server returns the record's Relay node
            // id (the store key), not the raw or global id the request happened to carry.
            type: 'NODE_DELETE',
            parentName: 'user',
            connectionName: 'testInvocations',
            deletedIDFieldName: 'deletedTestInvocationNodeId',
        }, {
            type: 'REQUIRED_CHILDREN',
            children: [Relay.QL`
                fragment on DeleteTestInvocationPayload {
                    deletedTestInvocationId
                    deletedTestInvocationNodeId
                    success
                    error
                }
            `],
        }];
    }

    getVariables() {
        return {
            testInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
        };
    }

    getOptimisticResponse() {
        return {
            deletedTestInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
            success: true,
        };
    }
}
